import {
  isMarketplaceAuction,
  isMarketplaceClientGuest,
  isMarketplaceDraw,
  isMarketplacePromoter,
  isMarketplacePurchaseDynamic,
  isMarketplaceResale,
} from '~admin/view/components/details/helper/marketplace.helper';
import { MarketplaceType } from '~client/model/marketplace-type';

/**
 * Returns TRUE when offer group suggestion increments need to be enabled
 * @param marketplaceType
 */
export const enableOfferSuggestions = (marketplaceType: MarketplaceType): boolean =>
  isMarketplacePurchaseDynamic(marketplaceType);

/**
 * Returns TRUE when at least one offer group is required for a marketplace
 * @param marketplaceType
 */
export const isOfferGroupRequired = (marketplaceType: MarketplaceType): boolean =>
  !isMarketplacePromoter(marketplaceType) &&
  !isMarketplaceResale(marketplaceType) &&
  !isMarketplaceClientGuest(marketplaceType);

/**
 * Returns TRUE when delete offer group button needs to be disabled
 * @param marketplaceType
 * @param offerGroupIndex
 */
export const disableOfferGroupDeleteButton = (
  marketplaceType: MarketplaceType,
  offerGroupIndex: number,
): boolean => isOfferGroupRequired(marketplaceType) && offerGroupIndex === 0;

/**
 * Returns TRUE when only one price is allowed thus disabling add button and disabling datetime fields
 * @param marketplaceType
 */
export const onlyOnePriceAllowed = (marketplaceType: MarketplaceType): boolean =>
  isMarketplaceAuction(marketplaceType) || isMarketplaceDraw(marketplaceType);



// WEBPACK FOOTER //
// ./view/components/details/offer-group-details/offer-group-fields.helper.ts